import {
    faBan,
    faBrakeWarning,
    faCarBurst,
    faHelmetSafety,
    faPersonDigging,
    faRightToBracket,
    faRoad,
    faRoadBarrier,
    fas,
    faSquareParking,
    faTriangleExclamation,
    faUser,
} from "@fortawesome/pro-solid-svg-icons";

import { Type_Language } from "src/api/input/types";
import { Type_Category, Type_Category_Style } from "src/types/category";

type Type_Category_Item = {
    id: number;
    title: Type_Language;
    style: Type_Category_Style;
    picto: string;
    hasChildren: boolean;
    parentId: number | null;
};

// This function helps organize the categories into a clear structure by emphasizing the parent first, followed by listing the children
export const sortedCategories = (categories: Type_Category[], lang: string) => {
    const categoryMap = new Map<number | null, Type_Category[]>();

    categories.forEach((category) => {
        if (!categoryMap.has(category?.parent_id)) {
            categoryMap.set(category?.parent_id, []);
        }
        categoryMap.get(category?.parent_id)!.push(category);
    });

    categoryMap.forEach((list) => {
        list.sort((a, b) => a.title[lang].localeCompare(b.title[lang]));
    });

    const sortedList: Type_Category_Item[] = [];
    const parents = categoryMap.get(null) || [];

    for (const parent of parents) {
        const queue: Type_Category[] = [parent];

        while (queue.length) {
            const category = queue.shift()!;

            sortedList.push({
                id: category.id,
                title: category.title,
                style: category.style,
                picto: category.picto,
                hasChildren: categoryMap.has(category.id),
                parentId: category?.parent_id ?? null,
            });

            if (categoryMap.has(category.id)) {
                queue.push(...categoryMap.get(category.id)!);
            }
        }
    }

    // supprime les listes sans type (tête de liste vide)
    return sortedList.filter(
        (value: Type_Category_Item): boolean =>
            !!value.parentId || value.hasChildren,
    );
};

type Type_Grouped_Category = Type_Category & {
    children?: Type_Category[];
};

export const groupCategoriesByParentId = (
    categories: Type_Category[],
): Type_Grouped_Category[] => {
    const parents: Type_Grouped_Category[] = categories.filter(
        (category) => category.parent_id === null,
    );

    const children = categories.filter(
        (category) => category.parent_id !== null,
    );

    parents.forEach((parent) => {
        parent.children = children.filter(
            (child) => child.parent_id === parent.id,
        );

        if (parent.children.length === 0) {
            parent.children.push(parent);
        }
    });

    return parents;
};

export const getIconFromPicto = (name: string) => {
    const nameParts = name.split(" ");
    const iconName = nameParts[nameParts.length - 1]
        .split("-")
        .map((part, index) => {
            return index === 0
                ? part
                : part.charAt(0).toUpperCase() + part.slice(1);
        })
        .join("");

    return fas[iconName];
};

export const pictoOptions = {
    "fa-solid fa-brake-warning": faBrakeWarning,
    "fa-solid fa-ban": faBan,
    "fa-solid fa-square-parking": faSquareParking,
    "fa-solid fa-right-to-bracket": faRightToBracket,
    "fa-solid fa-car-burst": faCarBurst,
    "fa-solid fa-person-digging": faPersonDigging,
    "fa-solid fa-helmet-safety": faHelmetSafety,
    "fa-solid fa-road-barrier": faRoadBarrier,
    "fa-solid fa-road": faRoad,
    "fa-solid fa-triangle-exclamation": faTriangleExclamation,
    "fa-solid fa-users": faUser,
};
